import { useTranslation } from '~/hooks/useTranslation'

export function useInterestKeys() {
  const { t } = useTranslation('InterestKeys')

  return {
    new_job: t('new_job'),
    career_change: t('career_change'),
    contract_job: t('contract_job'),
    working_for_self: t('working_for_self'),
    retirement: t('retirement'),
  }
}
